export default {
  title: "Page Not Found",
  body: "Sorry 😔, we couldn't find what you were looking for.",
  devHint: "Try creating a page in",
  goHome: "Go Home",
};
